module.exports = __webpack_public_path__ + "static/media/config.0788c6d7.svg";